import { ErrorActions } from "../components/ErrorActions";
import { ErrorDetails } from "../components/ErrorDetails";
import {
  baseFallbackCard as baseFallbackContent,
  baseFallbackContainer,
  baseFallbackMessage,
  baseFallbackTitle
} from "./BaseFallback.css";

/**
 * Props for the base error fallback component.
 */
interface BaseFallbackProps {
  /**
   * The error that was caught
   */
  error: Error;

  /**
   * If true, will display error details
   */
  displayErrorInfo?: boolean;

  /**
   * If true, the action buttons will display
   */
  displayActionButtons?: boolean;
}

/**
 * Base error fallback component with a clean, consistent UI.
 *
 * This component provides a nicely styled error display that can be used
 * for component-level, route-level, or app-level errors.
 */
export function BaseFallback({
  error,
  displayErrorInfo,
  displayActionButtons = false
}: BaseFallbackProps) {
  return (
    <div className={baseFallbackContainer}>
      <div className={baseFallbackContent}>
        <h1 className={baseFallbackTitle}>Something went wrong</h1>
        <p className={baseFallbackMessage}>
          We encountered an unexpected error. Please try reloading the
          application or contact support if the problem persists.
        </p>
        {displayActionButtons && <ErrorActions />}
        {displayErrorInfo && <ErrorDetails error={error} />}
      </div>
    </div>
  );
}
